import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiServiceBase } from 'src/app/Services/api.service.base';
import { LocalStorageService } from 'src/app/Services/local-storage.service';
import { PermissionsService } from 'src/app/Services/permissions.service';
import { FilterFiltersBase, IFilterFilters } from '../ifilter';

@Component({
    selector: '[app-permits-filter]',
    templateUrl: './permits-filter.component.html',
    styleUrls: ['./permits-filter.component.scss'],
    host: { 'class': 'control select' },
    standalone: false
})
export class PermitsFilterComponent extends FilterFiltersBase implements OnInit, IFilterFilters {

  constructor(private apiService: ApiServiceBase, private permissionsService: PermissionsService, route: ActivatedRoute) {
    super(route);
  }

  public FilterName: string = "permit";
  public Filters: any[] = [];
  public SelectedPermitType: any = "";
  public PermitTypes: any;
  @Input()
  public QueryParamPrefix: string= '';

  ngOnInit(): void {
    var vals = super.GetParamFields(this.QueryParamPrefix + this.FilterName);
    if(vals != null) {
      this.SelectedPermitType = vals[2];
    }

    if (this.SelectedPermitType != "") {
      this.Filters.push({
        Property: "ParkingPermitTypeId",
        Comparator: "==",
        Value: this.SelectedPermitType,
        FilterName: this.FilterName
      })
    }

    this.LoadPermitTypes();
  }

  private async LoadPermitTypes() {
    let requests: Promise<any[]>[] = [];

    if (await this.permissionsService.CheckAdminPermission("PermitsFeature", 100)) {
      requests.push(this.apiService.Get<any[]>("permits/standardpermittypes"));
      requests.push(this.apiService.Get<any[]>("permits/reservationpermittypes"));
    }
    if (await this.permissionsService.CheckAdminPermission("HotelReservationsFeature", 100)) {
      requests.push(this.apiService.Get<any[]>("permits/hotelreservationpermittypes"));
    }

    let results = await Promise.all(requests);
    this.PermitTypes = results.flat().sort((a, b) => a.Name.localeCompare(b.Name));
  }

  public addPermitTypeFilter(event: any) {
    var val = event.target.value;
    this.Filters = this.Filters.filter(x => x.Property != "ParkingPermitTypeId");

    if (val != "") {
      this.Filters.push({
        Property: "ParkingPermitTypeId",
        Comparator: "==",
        Value: val,
        FilterName: this.FilterName
      });

      this.SelectedPermitType = val;
    }
  }

  public ParkingPermitTypeSelected(permitType: any) {

    if (permitType.Id == this.SelectedPermitType) {
      return true;
    }

    return false;
  }

}
